import { useCifraClient } from "./cifra-client";

const { cifraClient } = useCifraClient();

export default {
  get(options) {
    return cifraClient.get('/api_publica/v1/roles', options)
  }
}